// extracted by mini-css-extract-plugin
export default {"imagegallerygrid":"videogallerygrid_imagegallerygrid__h1EO8","wrapperImages":"videogallerygrid_wrapperImages__1dE94","wrapperBtn":"videogallerygrid_wrapperBtn__UMiqO"};